// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"04dd8479","254":"b1929219","256":"f81657b0","339":"60b72a82","617":"0d2c93de","640":"cff99cac","657":"5fe3e447","869":"0e6b3ebf"}[chunkId] + ".chunk.js";
};